import Icon from 'veui/components/Icon'
import { IconCopy } from 'dls-icons-vue'

Icon.register('copy', IconCopy)
